import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateHome } from "../../../Redux/Slices/home.slice";
import { updateTrikes } from "../../../Redux/Slices/trikes.slice";
import { getTrikesV3 } from "../../../Redux/APIs/trikesAPI";

const ItemBody30 = ({ notification }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleViewDetails = async () => {
    dispatch(updateHome({ key: "notificationPopupVisible", value: false }));

    const trikeId =
      notification?.metaData?.trikeId || notification?.metaData?.trike_id;
    const registrationNo =
      notification?.metaData?.trikeRegistrationNo ||
      notification?.metaData?.trike_registration_no;

    let targetTrike = null;
    if (registrationNo || trikeId) {
      try {
        const response = await dispatch(
          getTrikesV3({ searchQuery: registrationNo || trikeId }),
        ).unwrap();
        const trikeList = response?.result || [];
        targetTrike = trikeList.find(
          (item) =>
            item.registrationNo === registrationNo ||
            Number(item.id) === Number(trikeId),
        );
        if (!targetTrike && trikeList.length > 0) {
          [targetTrike] = trikeList;
        }
        if (targetTrike) {
          dispatch(updateTrikes({ key: "currentTrike", value: targetTrike }));
        }
      } catch (err) {
        console.error("Error fetching trike for replacement notification", err);
      }
    }

    const navTarget = targetTrike?.registrationNo || registrationNo;
    if (navTarget) {
      navigate(`/assets/trikes/${navTarget}`);
    } else {
      navigate("/assets?tab=trikes");
    }
  };

  const agentName =
    notification?.metaData?.agentName ||
    notification?.metaData?.agent_name ||
    "Agent";
  const driverName =
    notification?.metaData?.driverName ||
    notification?.metaData?.driver_name ||
    "Driver";
  const registrationNo =
    notification?.metaData?.trikeRegistrationNo ||
    notification?.metaData?.trike_registration_no ||
    "Trike";
  const replacementReason =
    notification?.metaData?.replacementReason ||
    notification?.metaData?.replacement_reason ||
    "Trike replacement requested";

  return (
    <div>
      <p className="font-poppins text-xs font-light text-black">
        <span className="font-medium text-primary capitalize">
          {agentName}{" "}
        </span>
        has requested a replacement for trike{" "}
        <span className="font-medium">{registrationNo}</span> (Driver:{" "}
        <span className="font-medium">{driverName}</span>). Reason:{" "}
        <span className="font-medium">{replacementReason}</span>.
      </p>

      <div className="mt-2 w-full flex items-center gap-x-2">
        <button
          type="button"
          className="flex-1 bg-primary hover:bg-primary-50 py-2 px-4 text-center rounded-md cursor-pointer"
          onClick={handleViewDetails}
        >
          <p className="font-poppins text-xs font-medium text-background-white">
            View Details
          </p>
        </button>
      </div>
    </div>
  );
};

export default ItemBody30;
